export default __webpack_public_path__ + "static/singhvi-2c04d2f8eeb43a7a7ace05f6432a8cb4.jpg";